import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names conditionally using clsx and tailwind-merge.
 * heavily used utility function in components generated by shadcn/ui
 *
 * @example
 * cn('p-4', isActive && 'bg-blue-500') // returns "p-4 bg-blue-500" if isActive is truthy
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
